import React from "react";
import { Category } from "./Categories";

interface RibbonProps {
  activeCategory: Category;
  onChange: (category: Category) => void;
}

const Ribbon: React.FC<RibbonProps> = ({ activeCategory, onChange }) => {
  const options: { id: Category; label: string }[] = [
    { id: "patient", label: "Ασθενής" },
    { id: "patientAllergy", label: "Αλλεργίες" },
    { id: "patientClinicalScore", label: "Κλινικά Scores" },
    { id: "patientDocument", label: "Αποτελέσματα Εξετάσεων" },
    { id: "patientImplant", label: "Εμφυτεύματα" },
    { id: "patientRecord", label: "Ιστορικό " },
    { id: "patientRehabProtocol", label: "Πρωτόκολλα Αποκατάστασης" },
    { id: "patientMedicine", label: "Φαρμακευτικές Αγωγές" },
    { id: "patientSurgery", label: "Χειρουργεία" },
  ];

  return (
    <div className="bg-white border border-slate-200 rounded-xl p-1.5 flex gap-1 overflow-x-auto shadow-sm">
      {options.map((option) => {
        const isActive = activeCategory === option.id;

        return (
          <button
            key={option.id}
            onClick={() => onChange(option.id)}
            className={`px-4 py-2.5 text-sm font-medium rounded-lg transition-all whitespace-nowrap ${
              isActive
                ? "bg-primary border-primary text-white font-semibold shadow-sm"
                : "bg-transparent border-transparent text-slate-600 hover:bg-slate-100 hover:text-slate-900"
            }`}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default Ribbon;
